/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisabledIntegration } from './DisabledIntegration';
import {
    DisabledIntegrationFromJSON,
    DisabledIntegrationFromJSONTyped,
    DisabledIntegrationToJSON,
    DisabledIntegrationToJSONTyped,
} from './DisabledIntegration';

/**
 * 
 * @export
 * @interface DisabledIntegrationsResponse
 */
export interface DisabledIntegrationsResponse {
    /**
     * 
     */
    disabled_integrations: Array<DisabledIntegration>;
}

/**
 * Check if a given object implements the DisabledIntegrationsResponse interface.
 */
export function instanceOfDisabledIntegrationsResponse(value: object): value is DisabledIntegrationsResponse {
    if (!('disabled_integrations' in value) || value['disabled_integrations'] === undefined) return false;
    return true;
}

export function DisabledIntegrationsResponseFromJSON(json: any): DisabledIntegrationsResponse {
    return DisabledIntegrationsResponseFromJSONTyped(json, false);
}

export function DisabledIntegrationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisabledIntegrationsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'disabled_integrations': ((json['disabled_integrations'] as Array<any>).map(DisabledIntegrationFromJSON)),
    };
}

export function DisabledIntegrationsResponseToJSON(json: any): DisabledIntegrationsResponse {
    return DisabledIntegrationsResponseToJSONTyped(json, false);
}

export function DisabledIntegrationsResponseToJSONTyped(value?: DisabledIntegrationsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'disabled_integrations': ((value['disabled_integrations'] as Array<any>).map(DisabledIntegrationToJSON)),
    };
}

